// About.js
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function ServicesPage() {
  return (
    <Container className='public-page-container'>
      <h1>Servicios</h1>
      <Container className='representacion services-block p-0'>
        <Row>
          <Col md={4}>
            <img src='/mision-juvenil-logo.png' />
            <div className='text'>
              <p className='title'>Misión Juvenil FAMA</p>
              <p><Link to={'/formularios/requisitos-para-iniciar-el-servicio-de-mision-juvenil-fama.pdf'} target='_blank'>Requisitos para iniciar el Servicio de Misión Juvenil FAMA</Link></p>
              <p><Link to={'/formularios/formulario-de-solicitud-formal-para-implementar-mision-juvenil-fama.pdf'} target='_blank'>Formulario de Solicitud Formal para implementar Misión Juvenil FAMA</Link></p>
            </div>
          </Col>
          <Col md={4}>
            <img src='/alianza-matrimonial-logo.png' />
            <div className='text'>
              <p className='title'>Alianza Matrimonial</p>
              <p><Link to={'/formularios/requisitos-para-iniciar-el-servicio-de-alianza-matrimonial.pdf'} target='_blank'>Requisitos para iniciar el Servicio de Alianza Matrimonial</Link></p>
              <p><Link to={'/formularios/formulario-de-solicitud-formal-para-implementar-alianza-matrimonial.pdf'} target='_blank'>Formulario de Solicitud Formal para implementar Alianza Matrimonial</Link></p>
            </div>
          </Col>
          <Col md={4}>
            <img src='/iosef-logo.png' />
            <div className='text'>
              <p className='title'>Grupo de Niños IOSEF</p>
              <p><Link to={'/formularios/requisitos-para-iniciar-el-servicio-de-grupo-de-ninos-iosef.pdf'} target='_blank'>Requisitos para iniciar el Servicio de Grupo de Niños IOSEF</Link></p>
              <p><Link to={'/formularios/formulario-de-solicitud-formal-para-implementar-el-servicio-de-grupo-de-ninos-iosef.pdf'} target='_blank'>Formulario de Solicitud Formal para implementar el Servicio de Grupo de Niños IOSEF</Link></p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default ServicesPage;
